import { PlainDate } from "@/temporal"
import { objectSchema } from "vue-utils"
import { Nullable } from "../BaseEntity"
import { MarriageGender, MarriageGenderSchema } from "./MarriageGender"

export interface MarriagePersonDetails {
	Gender: Nullable<MarriageGender>
	Title: Nullable<string>
	FirstName: Nullable<string>
	LastName: Nullable<string>
	Email: Nullable<string>
	Mobile: Nullable<string>
	NINumber: Nullable<string>
	BirthDate: Nullable<PlainDate>
}

export const MarriagePersonDetails = objectSchema<MarriagePersonDetails>({
	Gender: Nullable(MarriageGenderSchema),
	Title: Nullable(String),
	FirstName: Nullable(String),
	LastName: Nullable(String),
	Email: Nullable(String),
	Mobile: Nullable(String),
	NINumber: Nullable(String),
	BirthDate: Nullable(PlainDate.Schema),
})
